import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useFavorisApi } from '@/features/services/favoris/FavorisServices'
import type { ContactAktoDTO } from '@/features/api/extranet/dto/shared'
import { useAppStateStore } from '@/features/application'

export type ContactAvecFavoris = ContactAktoDTO & { estFavoris: boolean }

export const useContactsFavorisStore = defineStore('contactsFavoris', () => {
  const appState = useAppStateStore()
  const favorisContactsApi = useFavorisApi<string[]>('contacts')
  const contactsFavoris = ref<string[] | null>([])
  const MAX_FAVORIS = 3

  async function chargerContactsFavoris() {
    contactsFavoris.value = (await favorisContactsApi.loadFavoris()) ?? []
  }

  async function ajouteContactAuxFavoris(email: string): Promise<boolean> {
    if ((contactsFavoris.value?.length ?? 0) >= MAX_FAVORIS) return false
    const emailsFavoris = [...new Set([...(contactsFavoris.value ?? []), email])]
    await enregistrerContactAuxFavoris(emailsFavoris)
    return true
  }

  async function supprimerContactDesFavoris(email: string) {
    const emailsFavoris = contactsFavoris.value?.filter((contact) => contact !== email) ?? []
    await enregistrerContactAuxFavoris(emailsFavoris)
  }

  async function enregistrerContactAuxFavoris(emails: string[]) {
    await favorisContactsApi.saveFavoris(emails)
    contactsFavoris.value = emails
  }

  async function nettoyerFavoris(emailsContacts: string[]) {
    if (!contactsFavoris.value) return

    const validFavorites = contactsFavoris.value.filter((email) => emailsContacts.includes(email))

    if (validFavorites.length !== contactsFavoris.value.length) {
      if (appState.estUtilisateurImpersonnalise) return
      await enregistrerContactAuxFavoris(validFavorites)
    }
  }

  function estContactFavori(email: string) {
    return contactsFavoris.value?.includes(email) ?? false
  }

  return {
    contactsFavoris,
    chargerContactsFavoris,
    ajouteContactAuxFavoris,
    supprimerContactDesFavoris,
    nettoyerFavoris,
    estContactFavori,
    MAX_FAVORIS,
  }
})
